import { DBSchema } from "idb";

export enum TACO_TABLE_NAMES {
  /**
   * An object store that can store simple key/value pairs that can be looked up by their keys. No indicies will be
   * created on this object store since it is not guaranteed that the values will be objects.
   */
  SIMPLE_KVP = "SIMPLE_KVP",
}

export interface TACO_IDB_DB extends DBSchema {
  [TACO_TABLE_NAMES.SIMPLE_KVP]: {
    key: IDBValidKey;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    value: any;
  };
}

// This needs to be updated whenever the schema is updated
// @see TACO_IDB_DB
export enum TACO_DB_VERSION {
  TACO_IDB_DB = 1,
}

export enum TACO_DB_NAMES {
  TACO_IDB_DB = "TACO_DB",
}
